import React, {Component} from 'react'
import PropTypes from 'prop-types'

class BasketCompletedItem extends Component {
    render() {
        return (
            <td className='text-center BasketCompletedItem'>
                <span style={{fontSize: '16px', fontWeight: 'bold', color: 'red', padding: '0 16px'}}>{this.props.totalItems - this.props.completedItems}</span>/ <span style={{fontSize: '16px', fontWeight: 'bold', color: '#28a745', padding: '0 16px'}}>{this.props.completedItems}</span>
            </td>
        )
    }
}

BasketCompletedItem.propTypes = {
    completedItems: PropTypes.number.isRequired,
}

export default BasketCompletedItem
